module.exports = new __parcel__URL__("Search.702e5fa0.svg").toString();